const initMarketsWeServiceSections = () => {
    [...document.querySelectorAll('.markets-we-service-section')]
        .filter(item => item.dataset.init !== 'true')
        .forEach((item) => initMarketsWeServiceSection(item));
};

const initMarketsWeServiceSection = (section) => {
    section.dataset.init = true;

    const items = section.querySelectorAll('.questions-items .item');

    items.forEach(item => {
        const question = item.querySelector('.question');

        question.addEventListener('click', () => {

            // Якщо клікнули на вже відкритий — закриваємо
            if (item.classList.contains('active')) {
                item.classList.remove('active');
                return;
            }

            // Закриваємо всі інші
            items.forEach(i => i.classList.remove('active'));

            // Відкриваємо поточний
            item.classList.add('active');
        });
    });
};

export { initMarketsWeServiceSections };
